// extracted by mini-css-extract-plugin
export default {"hero":"heroSection_hero__XOJB5","hero_container":"heroSection_hero_container__73qdp","hero_img_wrapper":"heroSection_hero_img_wrapper__HMUgS"};